import { render } from "./NoticeView.vue?vue&type=template&id=2067aa7b&scoped=true"
import script from "./NoticeView.vue?vue&type=script&lang=js"
export * from "./NoticeView.vue?vue&type=script&lang=js"

import "./NoticeView.vue?vue&type=style&index=0&id=2067aa7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2067aa7b"]])

export default __exports__